import React, { useState } from 'react';
import { Button } from 'react-bootstrap';

import MainContext from '../../contexts/MainContext';
import GetCrypto from './GetCrypto';
import DepositFromExchange from './DepositFromExchange';
import SelectCrypto from './SelectCrypto';

function AddFund({ needCrypto = false, buttonName = '' }) {
  // const walletType = localStorage.getItem('walletType');
  const { account = '' } = React.useContext(MainContext);
  const [showGetCryptoModal, setShowGetCryptoModal] = useState(false);
  const [showSelectCryptoModal, setShowSelectCryptoModal] = useState(false);
  const [showDepositFromExchangeModal, setShowDepositFromExchangeModal] =
    useState(false);

  // const addFundHandler = () => {
  //   if (isRegistered) {
  //     if (walletType === 'magic') showMagicWallet();
  //     else setShowGetCryptoModal(true);
  //   } else errorMsg(MSG.REGISTER);
  // };

  // const showMagicWallet = async () => {
  //   const magic = new Magic(MAGICLINK_PRIVATE_KEY, POLY_MAGICLINK_NODE);
  //   try {
  //     await magic.connect.showWallet();
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };

  const handleCloseAll = () => {
    setShowGetCryptoModal(false);
    setShowDepositFromExchangeModal(false);
    setShowSelectCryptoModal(false);
  };

  return (
    <>
      {needCrypto ? (
        <span
          onClick={() => setShowGetCryptoModal(true)}
          className="text-blue text-decoration-underline ps-2 cursor-pointer"
        >
          Grab some here
        </span>
      ) : (
        <Button
          onClick={() => setShowGetCryptoModal(true)}
          variant="primary"
          className="w-100"
        >
          {!buttonName ? 'Add Fund' : buttonName}
        </Button>
      )}
      {/* get crypto modal */}
      <GetCrypto
        handleClose={handleCloseAll}
        show={showGetCryptoModal}
        handleDepositFromCard={() => {
          setShowSelectCryptoModal(true);
          setShowGetCryptoModal(false);
        }}
        handleDepositFromExchnage={() => {
          setShowDepositFromExchangeModal(true);
          setShowGetCryptoModal(false);
        }}
      />

      {/* deposit from exchange modal */}
      <DepositFromExchange
        setShow={handleCloseAll}
        walletId={account}
        show={showDepositFromExchangeModal}
      />

      {/* select crypto modal */}
      <SelectCrypto handleClose={handleCloseAll} show={showSelectCryptoModal} />
    </>
  );
}

export default AddFund;
